(function ($) {
    $(document).ready(function () {

        hamburgerToggle();
        searchToggle();
        slickSlider();
        stickyNav();
    });

    function hamburgerToggle() {

        var $iconToggle         = $('.menu-toggle'),
            $offCanvasWrapper   = $('.off-canvas-wrapper');

        $offCanvasWrapper.on('opened.zf.offcanvas', function () {
            $iconToggle.toggleClass('is-active');
        }).on('closed.zf.offcanvas', function () {
            $iconToggle.toggleClass('is-active');
        });
    }

    function searchToggle() {
        var searchToggle    = $('.c-top-bar_search-toggle, .c-header_search-close'),
            searchForm      = $('.c-header_search');

        searchToggle.click(function() {
            searchForm.toggleClass('c-header_search--active');
        });
    }

    function slickSlider() {
        $('.c-treatment-row_slider').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev c-treatment-row_nav c-treatment-row_nav-left"><img src="../wp-content/themes/kcuc/assets/images/arrow-left.svg" class="c-treatment-row_arrows" alt="slider arrows"></button>',
            nextArrow: '<button type="button" class="slick-next c-treatment-row_nav c-treatment-row_nav-right"><img src="../wp-content/themes/kcuc/assets/images/arrow-right.svg" class="c-treatment-row_arrows" alt="slider arrows"></button>',
            responsive: [
                {
                    breakpoint: 860,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    function stickyNav() {
        window.onscroll = function () { myFunction() };

        var header = document.querySelector(".c-header"),
            offCanvasNav = document.querySelector('.c-offcanvas-nav'),
            sticky = header.offsetTop;

        function myFunction() {
            if (window.pageYOffset > sticky) {
                header.classList.add("is-sticky");
                offCanvasNav.classList.add('header-is-stuck');
            } else {
                header.classList.remove("is-sticky");
                offCanvasNav.classList.remove('header-is-stuck');
            }
        }
    }
})(jQuery);